/**
 * Created by mykurisu on 2017/9/11.
 */
import React from 'react'
import {Button} from 'react-weui'
import '../../styles/liveroom.css'
import NoneImage from '../../images/ban-no-item.png'
import {browserHistory}  from 'react-router'

class LiveroomNoneItem extends React.Component {
    constructor(){
        super();
    }
    handleCreateLecture() {
        location.assign(`/liveroom/${this.props.id}/lecture/create`)
    }
    render() {
        const {role} = this.props;

        return (
            <div className="liveroom-no-item">
                {role.is_manager ?
                    <div className="liveroom-no-item-main">
                        <img src="https://static-1253442168.image.myqcloud.com/picture/6163344_8b3fe40726664723210eb6eb723fa62a.jpg" alt="" style={{marginBottom:'5px'}}/>
                        <p>本直播间暂无内容，请创建课程，或点击右下</p>
                        <p>方“操作”，进入“转载中心”把课程转到本直播间</p>
                        <Button className="createLecBtn" onClick={() => this.handleCreateLecture()}>创建课程</Button>
                    </div>
                :
                    <div className="liveroom-no-item-main">
                        <img src={NoneImage} alt=""/>
                        <p>当前直播间暂无内容</p>
                        <p>回到首页浏览更多课程</p>
                        <Button size="small" onClick={() => window.location.href = '/'}>回到首页</Button>
                    </div>
                }
            </div>
        )
    }
}

export default LiveroomNoneItem



// WEBPACK FOOTER //
// ./src/components/liveroom/LiveroomNoneItem.js